import { HStack, Pressable, VStack, View } from "@gluestack-ui/themed";
import { Text } from "@repo/core/components/core/Text";
import { Icon } from "@repo/core/components/core/Icon";
import { InterestTypeButtonProps } from "./types";

export const InterestTypeButton = ({
  isSelected,
  onPress,
  title,
  subtitle,
  isDisabled
}: InterestTypeButtonProps) => {
  return (
    <Pressable
      flex={1}
      borderWidth={1}
      borderColor={isSelected ? "$primary700" : "$borderLight200"}
      borderRadius="$md"
      bg={isSelected ? "$primary0" : "$backgroundLight50"}
      p="$2"
      pl="$3"
      onPress={onPress}
      disabled={isDisabled}
    >
      <HStack gap={12}>
        <VStack flex={1}>
          <Text
            color="$textLight900"
            fontSize="$sm"
            fontWeight={600}
            lineHeight={20}
          >
            {title}
          </Text>
          {subtitle && (
            <Text fontSize="$xs" color="$textLight800" lineHeight={20}>
              {subtitle}
            </Text>
          )}
        </VStack>
        <View position="absolute" top={0} right={0}>
          {isSelected && (
            <Icon
              name="check-circle"
              color="$primary700"
              size={20}
              variant="solid"
            />
          )}
        </View>
      </HStack>
    </Pressable>
  );
};
